import { Box, Drawer, makeStyles } from "@material-ui/core";
import { useRecoilValue } from "recoil";
import { bottomDrawerState, bottomFixedDrawerState, breadCrumbsState } from "../../store/layout";
import BottomDrawerButtons from "./BottomDrawerButtons";

export default function BottomDrawer() {
	const bottomDrawer = useRecoilValue(bottomDrawerState);
	const bottomFixedDrawer = useRecoilValue(bottomFixedDrawerState);
	const breadcrumbs = useRecoilValue(breadCrumbsState);
	const classes = useStyles();

	if (bottomDrawer) {
		return (
			<Box className={classes.bottomDrawer} marginBottom={breadcrumbs?.links.length ? 6 : 0}>
				<Box className={`${classes.container}`}>
					<BottomDrawerButtons component={bottomDrawer as any} />
				</Box>
			</Box>
		);
	}
	if (bottomFixedDrawer) {
		return (
			<Box>
				<Drawer variant="permanent" anchor="bottom" open classes={{ paper: classes.bottomDrawer }}>
					<Box className={`${classes.container}`}>
						<BottomDrawerButtons component={bottomFixedDrawer as any} />
					</Box>
				</Drawer>
			</Box>
		);
	}

	return <div style={{ display: "none" }} />;
}

const useStyles = makeStyles((theme) => ({
	bottomDrawer: {
		zIndex: 100,
		backgroundColor: theme.palette.background.paper,
		padding: theme.spacing(1),
		border: "none",
		boxShadow: theme.shadows[3],
		width: "100%",
	},
	container: {
		display: "flex",
		justifyContent: "space-between",
	},
}));
